"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ImageSource_1 = __importDefault(require("../classes/ImageSource"));
const Tilemap_1 = __importDefault(require("../classes/Tilemap"));
const Tileset_1 = __importDefault(require("../classes/Tileset"));
const map_json_1 = __importDefault(require("../tilemaps/map.json"));
const map_2_json_1 = __importDefault(require("../tilemaps/map-2.json"));
const map_3_json_1 = __importDefault(require("../tilemaps/map-3.json"));
const floors_json_1 = __importDefault(require("../tilesets/floors.json"));
const walls_json_1 = __importDefault(require("../tilesets/walls.json"));
const furniture_json_1 = __importDefault(require("../tilesets/furniture.json"));
const collision_json_1 = __importDefault(require("../tilesets/collision.json"));
const obstacles_json_1 = __importDefault(require("../tilesets/obstacles.json"));
const AudioSource_1 = __importDefault(require("../classes/AudioSource"));
const MusicTrack_1 = __importDefault(require("../classes/MusicTrack"));
const Noise_1 = __importDefault(require("../classes/Noise"));
const define = () => {
    new Tilemap_1.default("map", map_json_1.default);
    new Tilemap_1.default("map-2", map_2_json_1.default);
    new Tilemap_1.default("map-3", map_3_json_1.default);
    new ImageSource_1.default("coots");
    new Tileset_1.default("floors", floors_json_1.default);
    new Tileset_1.default("walls", walls_json_1.default);
    new Tileset_1.default("furniture", furniture_json_1.default);
    new Tileset_1.default("collision", collision_json_1.default);
    new Tileset_1.default("obstacles", obstacles_json_1.default);
    new ImageSource_1.default("tilesets/floors");
    new ImageSource_1.default("tilesets/walls");
    new ImageSource_1.default("tilesets/furniture");
    new ImageSource_1.default("tilesets/collision");
    new ImageSource_1.default("tilesets/obstacles");
    new ImageSource_1.default("indicator");
    new ImageSource_1.default("interact-hud");
    new ImageSource_1.default("game-over");
    new ImageSource_1.default("victory");
    new ImageSource_1.default("scratch");
    new ImageSource_1.default("title");
    new ImageSource_1.default("pattern");
    new ImageSource_1.default("buttons/next");
    new ImageSource_1.default("hunger");
    new ImageSource_1.default("eating");
    new ImageSource_1.default("bed");
    new AudioSource_1.default("music/title", 0);
    new AudioSource_1.default("music/main", 132000);
    new AudioSource_1.default("music/victory", 70500);
    new AudioSource_1.default("music/defeat", null);
    new AudioSource_1.default("music/level", null);
    new MusicTrack_1.default("title", { audioSourceSlug: "music/title" });
    new MusicTrack_1.default("main", { audioSourceSlug: "music/main" });
    new MusicTrack_1.default("victory", { audioSourceSlug: "music/victory" });
    new MusicTrack_1.default("defeat", { audioSourceSlug: "music/defeat" });
    new MusicTrack_1.default("level", { audioSourceSlug: "music/level" });
    new AudioSource_1.default("noises/scratch", null);
    new AudioSource_1.default("noises/meow", null);
    new AudioSource_1.default("noises/bounce", null);
    new AudioSource_1.default("noises/destroy/electronic", null);
    new AudioSource_1.default("noises/destroy/wood", null);
    new AudioSource_1.default("noises/destroy/scratch", null);
    new AudioSource_1.default("noises/destroy/cloth", null);
    new AudioSource_1.default("noises/destroy/container", null);
    new Noise_1.default("scratch", { audioSourceSlug: "noises/scratch" });
    new Noise_1.default("meow", { audioSourceSlug: "noises/meow" });
    new Noise_1.default("bounce", { audioSourceSlug: "noises/bounce" });
    new Noise_1.default("destroy/electronic", { audioSourceSlug: "noises/destroy/electronic" });
    new Noise_1.default("destroy/wood", { audioSourceSlug: "noises/destroy/wood" });
    new Noise_1.default("destroy/scratch", { audioSourceSlug: "noises/destroy/scratch" });
    new Noise_1.default("destroy/cloth", { audioSourceSlug: "noises/destroy/cloth" });
    new Noise_1.default("destroy/container", { audioSourceSlug: "noises/destroy/container" });
};
exports.default = define;
